/**
 * Dashboard API — one place, easily mockable. Uses XHR to bypass Emergent's
 * fetch-wrapping preview scripts (same reason as AuthContext).
 */
const API = process.env.REACT_APP_BACKEND_URL;

function request(method, path, body) {
  const token = localStorage.getItem('selora_token') || '';
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, `${API}${path}`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.onload = () => {
      const text = xhr.responseText || '';
      let data = {};
      if (text) { try { data = JSON.parse(text); } catch { data = { detail: text }; } }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new Error(data.detail || `HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(body ? JSON.stringify(body) : null);
  });
}

export const getDashboardSummary = () => request('GET', '/api/dashboard/summary');
export const getProfile         = () => request('GET', '/api/profile');
export const patchProfile       = (patch) => request('PATCH', '/api/profile', patch);
export const listProgress       = () => request('GET', '/api/progress');
export const upsertProgress     = (body) => request('POST', '/api/progress', body);
export const mySubmissions      = () => request('GET', '/api/submissions/my');
export const cancelSubscription = (id, cancelAtCycleEnd = true) =>
  request('POST', `/api/payments/subscriptions/${id}/cancel?cancel_at_cycle_end=${cancelAtCycleEnd}`);
export const myOrders           = () => request('GET', '/api/orders/mine');
export const mySubscriptions    = () => request('GET', '/api/subscriptions/mine');
export const myBookings         = () => request('GET', '/api/bookings/mine');
export const createBooking      = (body) => request('POST', '/api/bookings', body);
export const myNotifications    = () => request('GET', '/api/notifications/mine');
export const markNotificationRead = (id) => request('POST', `/api/notifications/${id}/read`);
export const myRewards          = () => request('GET', '/api/rewards/mine');
